module.exports = __webpack_public_path__ + "static/Cherry-bc5b5f1c9bf4b190607268135151c840.png";